import React from 'react';
import { heroData } from '../data/mock';
import { ChevronDown, Building2 } from 'lucide-react';

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-background">
        <img 
          src={heroData.heroBackground} 
          alt="Cross-continental infrastructure and modern bridge engineering projects" 
          className="hero-image"
        />
        <div className="hero-overlay"></div>
      </div>
      
      <div className="hero-content">
        <div className="hero-grid">
          <div className="hero-text-content">
            <div className="hero-badge">
              <Building2 size={16} />
              <span>Redspire Civil Engineering</span>
            </div>
            <h1 className="brand-display">{heroData.name}</h1>
            <p className="hero-title">{heroData.title}</p>
            <p className="hero-tagline">{heroData.tagline}</p>
            <div className="hero-cta-group">
              <a href="#biography" className="btn-primary">Read Biography</a>
              <a href="tel:+15124348560" className="btn-secondary">Get in Touch</a>
            </div>
          </div>
          
          <div className="hero-portrait-container">
            <div className="hero-portrait-wrapper">
              <img 
                src={heroData.avatarUrl} 
                alt="Ruben P. Wargner, Founder and Chief Strategy Officer of Redspire Civil Engineering"
                className="hero-portrait"
              />
              <div className="portrait-accent"></div>
            </div>
          </div>
        </div>
      </div>
      
      <a href="#achievements" className="scroll-indicator">
        <ChevronDown size={32} />
      </a>
    </section>
  );
};

export default HeroSection;